'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toBlockStatement = toBlockStatement;
exports.toStatement = toStatement;
exports.toFunctionBody = toFunctionBody;
exports.ensureBlockBody = ensureBlockBody;
exports.blockToExpression = blockToExpression;
exports.getScopeParent = getScopeParent;
exports.iife = iife;

var _types = require('./types');

var _types2 = _interopRequireDefault(_types);

var _is = require('./is');

var _is2 = _interopRequireDefault(_is);

var _statementsToExpression = require('./util/statementsToExpression');

var _statementsToExpression2 = _interopRequireDefault(_statementsToExpression);

var _astLocUtils = require('ast-loc-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toBlockStatement(body) {
  var bodyLoc = (0, _astLocUtils.getLoc)(body);

  if ((0, _is.isa)(body, "BlockStatement")) {
    return body;
  } else if ((0, _is.isa)(body, "Statement")) {
    return (0, _astLocUtils.buildAtLoc)(bodyLoc, _types2.default.blockStatement, [body]);
  } else {
    return (0, _astLocUtils.buildAtLoc)(bodyLoc, _types2.default.blockStatement, [(0, _astLocUtils.buildAtLoc)(bodyLoc, _types2.default.expressionStatement, body)]);
  }
}function toStatement(body) {
  if ((0, _is.isa)(body, "Expression")) {
    return (0, _astLocUtils.buildAtLoc)((0, _astLocUtils.getLoc)(body), _types2.default.expressionStatement, body);
  } else {
    return body;
  }
}function toFunctionBody(body) {
  if ((0, _is.isa)(body, "Expression")) {
    return body;
  } else {
    return toBlockStatement(body);
  }
}function ensureBlockBody(path) {
  if (!(0, _is2.default)("BlockStatement", path.node.body)) {
    return path.get("body").replaceWith((0, _astLocUtils.buildAtLoc)((0, _astLocUtils.getLoc)(path.node.body), _types2.default.blockStatement, [path.node.body]));
  }
}function blockToExpression(path) {
  var node = path.node;

  if ((0, _is.isa)(node, "BlockStatement")) {
    return (0, _statementsToExpression2.default)(path, path.node.body);
  } else if ((0, _is.isa)(node, "FunctionDeclaration")) {
    // Special case: the parser promotes a block consisting of a single declaration
    // from ExprStatement(FunctionExpr) to FunctionDeclaration. Convert back to
    // expression here.
    var nextNode = _types2.default.clone(node);
    if (nextNode.type === "NamedArrowDeclaration") {
      nextNode.type = "NamedArrowExpression";
    } else {
      nextNode.type = "FunctionExpression";
    }return nextNode;
  } else if ((0, _is.isa)(node, "ExpressionStatement")) {
    return node.expression;
  } else {
    return node;
  }
}function getScopeParent(path) {
  return path.findParent(function (path) {
    return path.isFunction() || path.isBlockStatement() || path.isProgram();
  });
}function iife(body) {
  var async = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var actualBody = Array.isArray(body) ? function () {
    var bodyLoc = (0, _astLocUtils.getSurroundingLoc)(body);
    return (0, _astLocUtils.placeAtLoc)(_types2.default.blockStatement(body), bodyLoc);
  }() : toBlockStatement(body);

  var loc = (0, _astLocUtils.getLoc)(actualBody);

  return (0, _astLocUtils.placeAtLoc)(_types2.default.callExpression((0, _astLocUtils.placeAtLoc)(_types2.default.arrowFunctionExpression([], actualBody, async), loc), []), loc);
}